import convention from '@/components/surveillance/impl/convention'

import modules from '@/sui/data/modules'
import units from '@/sui/data/units'
import distribution from '@/sui/tools/distribution'
import caracteristics from '@/sui/data/caracteristics'

import moment from 'moment'

const reaSinkStatus = [
  'inscrit',
  'attente éc.',
  'éc. envoyés',
  'éc. reçus',
  'éc. retournés',
  'labo',
  'clôturé'
]

const reaExplaurStatus = [
  'inscrit',
  'attente éc.',
  'éc. envoyés',
  'éc. reçus'
]

const common = [
  { key: 'e', field: 'establishment', name: `Nom de l'établissement` },
  { key: 'f', field: 'finess', name: 'Finess' },
  { key: 'r', field: 'referent', name: 'Responsable' },
  { key: 'cs', field: 'conventionStatus', name: 'Statut de la charte' },
  { key: 'id', field: 'id', name: `ID de l'inscription` },
  { key: 'b', field: 'bactADIValue', name: 'Bact ADI (oui/non)' },
  { key: 'ri', field: 'reaInfADIValue', name: 'Réa Inf ADI (oui/non)' },
  { key: 'ni', field: 'neoInfADIValue', name: 'Néo Inf ADI (oui/non)' },
  { key: 'di', field: 'diaInfADIValue', name: 'Dia Inf ADI (oui/non)' },
  { key: 'bs', field: 'bactADISheets', name: 'Fiches Bact ADI (oui/non)' },
  { key: 'ris', field: 'reaInfADISheets', name: 'Fiches Réa Inf ADI (oui/non)' },
  { key: 'nis', field: 'neoInfADISheets', name: 'Fiches Néo Inf ADI (oui/non)' },
  { key: 'dis', field: 'diaInfADISheets', name: 'Fiches Dia Inf ADI (oui/non)' },
  { key: 'riuf', field: 'reaInfADIUFs', name: 'UFs Réa Inf ADI' },
  { key: 'niuf', field: 'neoInfADIUFs', name: 'Ufs Néo Inf ADI' },
  { key: 'diuf', field: 'diaInfADIUFs', name: 'Ufs Dia Inf ADI' }
]

const current = [
  {
    key: 'ess',
    field: 'estbSheetStatus',
    name: 'Statut de la fiche établissement (absent/open/valid)'
  },
  {
    key: 'tus',
    field: 'toolsUsageSheetStatus',
    name: 'Statut de la fiche formation (absent/open/valid)'
  },
  { key: 'ty', field: 'estbType', name: `Type d'établissement` },
  { key: 'es', field: 'endStatus', name: 'Statut' },
  { key: 'o4', field: 'observa4Value', name: 'OBSERVA4 (oui/non)' },
  { key: 'o4s', field: 'observa4Sheets', name: 'Fiches OBSERVA4 (oui/non)' }
]

const expADI = [
  { key: 'ea', field: 'expADIValue', name: 'Exp ADI (oui/non)' },
  { key: 'eas', field: 'expADISheets', name: 'Fiches Exp ADI (oui/non)' },
  { key: 'eauf', field: 'expADIUFs', name: 'UFs Exp ADI' }
]

const withExplaur = [
  ...common,
  ...current,
  ...expADI,
  { key: 'rx', field: 'reaExplaurValue', name: 'RÉA-explAUR (oui/non)' },
  { key: 'rxuf', field: 'reaExplaurUfs', name: 'UF RÉA-explAUR' },
  { key: 'rxs', field: 'reaExplaurStatus', name: 'Statut RÉA-explAUR' }
]

const withTopCvp = [
  ...withExplaur,
  { key: 'cvp', field: 'topCvpValue', name: 'Top CVP (oui/non)' },
  { key: 'cvpuf', field: 'topCvpValueUfs', name: 'UF Top CVP' }
]

const withSpy4AndBadiCause = [
  ...withExplaur,
  { key: 'bc', field: 'badiCauseValue', name: 'Badi CAUSE (oui/non)' },
  { key: 'bcs', field: 'badiCauseSheets', name: 'Fiches Badi CAUSE' },
  { key: 'spy4', field: 'spy4Value', name: 'SPY4 (oui/non)' },
  { key: 'spy4s', field: 'spy4Sheets', name: 'Fiches SPY4' }
]

const expADIExport = [
  { key: 'expADIValue', header: 'ExpADI' },
  { key: 'expADISheets', header: 'Fiches ExpADI' },
  { key: 'expADIUFs', header: 'Services ExpADI' }
]

const currentExport = function (add, o4) {
  const result = [
    { key: 'registration', header: `Date d'inscription` },
    { key: 'establishment', header: 'Établissement' },
    { key: 'finess', header: 'Finess' },
    { key: 'town', header: 'Ville' },
    { key: 'region', header: 'Région' },
    { key: 'refName', header: 'Référent' },
    { key: 'referent', header: 'E-mail référent' },
    { key: 'endStatus', header: 'Statut' },
    { key: 'conventionStatus', header: 'Charte' },
    { key: 'estbSheetStatus', header: 'Fiche établissement' },
    { key: 'toolsUsageSheetStatus', header: 'Fiche formation' },
    { key: 'estbType', header: `Type d'établissement` },
    { key: 'bactADIValue', header: 'Bact ADI' },
    { key: 'bactADISheets', header: 'Fiches Bact ADI' },
    ...add,
    { key: 'reaInfADIValue', header: 'Réa-InfADI' },
    { key: 'reaInfADISheets', header: 'Fiches Réa-InfADI' },
    { key: 'reaInfADIUFs', header: 'Services Réa-InfADI' },
    { key: 'diaInfADIValue', header: 'Dia-InfADI' },
    { key: 'diaInfADISheets', header: 'Fiches Dia-InfADI' },
    { key: 'diaInfADIUFs', header: 'Services Dia-InfADI' },
    { key: 'neoInfADIValue', header: 'Néo-InfADI' },
    { key: 'neoInfADISheets', header: 'Fiches Néo-InfADI' },
    { key: 'neoInfADIUFs', header: 'Services Néo-InfADI' }
  ]
  if (o4) {
    result.push(
      { key: 'observa4Value', header: 'OBSERVA4' },
      { key: 'observa4Sheets', header: 'Fiches OBSERVA4' }
    )
  }

  return result
}

function getDatasetStatus (module, year) {
  if (module == null || module.dset == null) {
    return null
  }
  const dset = module.dset.find(d => d.name === `SPIADI${year}`)
  if (dset == null) {
    return null
  }

  if (dset.step === 0) {
    return 'p'
  }

  if (dset.step === 1) {
    return 'pf'
  }

  return 'pfd'
}

function getIcon (icon, icons, t) {
  let r = icon
  if (icons[t] != null) {
    r = icons[t]
  }
  return `${r}`
}

function caracteristicsBuilder (year) {
  const protocols = modules.get(year)
  const pcav = []
  const ocav = []
  const rcav = []
  const ppcav = []
  for (let key in protocols) {
    const p = protocols[key]
    const m = { code: key, value: p.label, color: p.color }
    if (p.type === modules.types.observation) {
      ocav.push(m)
    } else if (p.type === modules.types.surveillance) {
      pcav.push(m)
      if (p.units != null) {
        ppcav.push(m)
      }
    } else if (p.type === modules.types.causeAnalysis) {
      rcav.push(m)
    }
  }

  const obss = year === '2020' ? `Réa-Sink` : `RÉA-explAUR`

  return (list) => {
    const tables = [
      {
        key: 'protocols',
        list: [
          {
            f: 'nomod',
            t: 'Nombre de modalités par établissement',
            v: [
              { code: 0, value: 'Aucun' },
              { code: 1, value: 'Une modalité ou plus' }
            ]
          },
          {
            f: 'protocol',
            t: 'Modalités de surveillance',
            v: pcav
          },
          {
            f: 'services',
            t: 'Services participant aux surveillances patients',
            v: ppcav
          },
          {
            f: 'obs',
            t: `Modalités d'observation des pratiques`,
            v: ocav
          },
          {
            f: 'servobs',
            t: `Services participant à ${obss}`,
            v: ocav
          },
          {
            f: 'ana',
            t: `Modalités d'analyse des causes`,
            v: rcav
          }
        ],
        open: true,
        title: 'Modalités'
      }
    ]

    const tests = [
      {
        key: 'nomod',
        type: 'rep',
        apply: (b, s) => {
          const v = s.source.availableSurveillanceModules.length === 0 ? 0 : 1
          b.increment(v)
        }
      },

      {
        key: 'protocol',
        type: 'reph',
        apply: (b, s) => {
          s.source.availableSurveillanceModules.forEach(
            m => { b.increment(m) }
          )
        }
      },

      {
        key: 'services',
        type: 'reph',
        apply: (b, s) => {
          s.source.availableSurveillanceModules.forEach(
            m => {
              const ufs = s.source.getUfs(m)
              if (ufs != null && ufs.length > 0) {
                b.incrementN(m, ufs.length)
              }
            }
          )
        }
      },

      {
        key: 'obs',
        type: 'reph',
        apply: (b, s) => {
          s.source.availableObservationModules.forEach(
            m => { b.increment(m) }
          )
        }
      },

      {
        key: 'servobs',
        type: 'reph',
        apply: (b, s) => {
          s.source.availableObservationModules.forEach(
            m => {
              const ufs = s.source.getUfs(m)
              if (ufs != null && ufs.length > 0) {
                b.increment(m, ufs.length)
              }
            }
          )
        }
      },

      {
        key: 'ana',
        type: 'reph',
        apply: (b, s) => {
          s.source.availableCauseAnalysisModules.forEach(
            m => { b.increment(m) }
          )
        }
      }
    ]

    const source = distribution.extract(list, tests)
    const result = caracteristics.flatten.flatten(tables, source)
    return result
  }
}

export default {
  caracteristicsBuilder,

  booleanIcons: function (t) {
    const list = {
      Oui: '🔵',
      Non: '⚪'
    }

    for (let i in list) {
      if (t.startsWith(i)) {
        return t.replace(i, list[i])
      }
    }
    return t
  },

  getConventionStatus: function (t) {
    return getIcon(
      '',
      [
        '',
        convention.icons.uploaded,
        convention.icons.validated,
        convention.icons.refused,
        convention.icons.edited
      ],
      t
    )
  },

  getSingleSheetsStatus: function (t) {
    return getIcon(
      '',
      {
        open: '✏️',
        valid: '✅'
      },
      t
    )
  },

  listValues: {
    reaSink: function (v, s) {
      const { reaSink } = s.modules
      if (reaSink != null) {
        const key = 'reaSinkStatus'
        const status = reaSinkStatus[reaSink.status.val]
        const dt = new Date(reaSink.status.date)
        const date = moment(dt).format('DD/MM/YYYY HH:mm')
        v[key] = `${status} (${date})`
        v['reaSinkExportDate'] = date
        v['reaSinkExportStatus'] = status
      }
    },

    reaExplaur: function (v, s) {
      const { reaExplaur } = s.modules
      if (reaExplaur != null) {
        const key = 'reaExplaurStatus'
        const status = reaExplaurStatus[reaExplaur.stat.val]
        const dt = new Date(reaExplaur.stat.date)
        const date = moment(dt).format('DD/MM/YYYY HH:mm')
        v[key] = `${status}\n${date}`
        v['reaExplaurExportDate'] = date
        v['reaExplaurExportStatus'] = status
      }
    }
  },

  buildModule: function (v, s, t, y) {
    const module = s.modules[t]
    const def = modules.get(y)[t]
    if (def.units == null) {
      if (module == null) {
        v[`${t}Value`] = 'Non'
      } else {
        let result = 'Oui'
        const status = getDatasetStatus(module, y)
        if (status != null) {
          result += `<br />[${status}]`
        }
        v[`${t}Value`] = result
      }
      return
    }

    if (module == null) {
      v[`${t}Value`] = 'Non'
      v[`${t}UFs`] = ''
      return
    }

    const ufs = s.getUfs(t)
    const status = getDatasetStatus(module, y)
    if (status == null) {
      v[`${t}Value`] = `Oui (${ufs.length})`
    } else {
      v[`${t}Value`] = `Oui (${ufs.length}) [${status}]`
    }

    const uy = units[`${y}`]
    let result = ''
    ufs.forEach(
      (u, i) => {
        const type = uy.findFromIndex(u.ufType).code
        result += `${u.name} <small>(${type})</small><br/>`
      }
    )
    v[`${t}UFs`] = result
  },

  filterVariables: {
    '2019': [
      ...common,
      ...current,
      { key: 'c', field: 'closed', name: 'Clôture' },
      { key: 'rb', field: 'reaBactADIValue', name: 'Réa Bact ADI' },
      { key: 'rbs', field: 'reaBactADISheets', name: 'Fiches Réa Bact ADI' },
      { key: 'rbuf', field: 'reaBactADIUFs', name: 'UFs Réa Bact ADI' }
    ],
    '2020': [
      ...common,
      ...current,
      ...expADI,
      { key: 'rs', field: 'reaSinkValue', name: 'Réa-Sink (oui/non)' },
      { key: 'rsuf', field: 'reaSinkUfs', name: 'UF Réa-Sink' },
      { key: 'rss', field: 'reaSinkStatus', name: 'Statut Réa-Sink' }
    ],
    '2021': withExplaur,
    '2022': withExplaur,
    '2023': withExplaur,
    '2024': withExplaur,
    '2025': withTopCvp,
    '2026': withSpy4AndBadiCause
  },

  exportColumns: {
    '2019': [
      ...currentExport(
        [
          { key: 'reaBactADI', header: 'Réa Bact ADI' },
          { key: 'reaBactADIUFs', header: 'Services Réa Bact ADI' },
          { key: 'reaBactADISheets', header: 'Fiches Réa Bact ADI' }
        ],
        false
      )
    ],

    '2020': [
      ...currentExport(expADIExport, true),
      { key: 'reaSink', header: 'Réa-Sink' },
      { key: 'reaSinkUFs', header: 'Service Réa-Sink' },
      { key: 'reaSinkExportStatus', header: 'Statut Réa-Sink' },
      { key: 'reaSinkExportDate', header: 'Date du changement de statut Réa-Sink' }
    ],

    '2021': [
      ...currentExport(expADIExport, true),
      { key: 'reaExplaurValue', header: 'RÉA-explAUR' },
      { key: 'reaExplaurUFs', header: 'Service RÉA-explAUR' },
      { key: 'reaExplaurExportStatus', header: 'Statut RÉA-explAUR' },
      { key: 'reaExplaurExportDate', header: 'Date du changement de statut RÉA-explAUR' }
    ],

    '2022': [
      ...currentExport(expADIExport, true),
      { key: 'reaExplaurValue', header: 'RÉA-explAUR' },
      { key: 'reaExplaurUFs', header: 'Service RÉA-explAUR' },
      { key: 'reaExplaurExportStatus', header: 'Statut RÉA-explAUR' },
      { key: 'reaExplaurExportDate', header: 'Date du changement de statut RÉA-explAUR' }
    ],

    '2023': [
      ...currentExport(expADIExport, true),
      { key: 'reaExplaurValue', header: 'RÉA-explAUR' },
      { key: 'reaExplaurUFs', header: 'Service RÉA-explAUR' },
      { key: 'reaExplaurExportStatus', header: 'Statut RÉA-explAUR' },
      { key: 'reaExplaurExportDate', header: 'Date du changement de statut RÉA-explAUR' }
    ],

    '2024': [
      ...currentExport(expADIExport, true),
      { key: 'reaExplaurValue', header: 'RÉA-explAUR' },
      { key: 'reaExplaurUFs', header: 'Service RÉA-explAUR' },
      { key: 'reaExplaurExportStatus', header: 'Statut RÉA-explAUR' },
      { key: 'reaExplaurExportDate', header: 'Date du changement de statut RÉA-explAUR' }
    ],

    '2025': [
      ...currentExport(expADIExport, true),
      { key: 'reaExplaurValue', header: 'RÉA-explAUR' },
      { key: 'reaExplaurUFs', header: 'Service RÉA-explAUR' },
      { key: 'reaExplaurExportStatus', header: 'Statut RÉA-explAUR' },
      { key: 'reaExplaurExportDate', header: 'Date du changement de statut RÉA-explAUR' },
      { key: 'topCvpValue', header: 'Top CVP' },
      { key: 'topCvpUFs', header: 'Services Top CVP' }
    ],

    '2026': [
      ...currentExport(expADIExport, true),
      { key: 'reaExplaurValue', header: 'RÉA-explAUR' },
      { key: 'reaExplaurUFs', header: 'Service RÉA-explAUR' },
      { key: 'reaExplaurExportStatus', header: 'Statut RÉA-explAUR' },
      { key: 'reaExplaurExportDate', header: 'Date du changement de statut RÉA-explAUR' },
      { key: 'badiCauseValue', header: 'Badi CAUSE' },
      { key: 'badiCauseSheets', header: 'Fiches Badi CAUSE' },
      { key: 'spy4Value', header: 'SPY4' },
      { key: 'spy4Sheets', header: 'Fiches SPY4' }
    ]
  },

  buildTable: function (year, ufs, lstate, sheets) {
    const cl = 'table-column-filter'
    const col = (e, f) => `${e} <span class='${cl}'>(${f})</span>`
    const spe = (e) => ufs ? `${e}uf` : e
    const field = (e) => ufs ? `${e}UFs` : `${e}Value`
    const common = {
      columns: [
        {
          html: col('Établissement', '$e'),
          field: 'establishment'
        },
        {
          html: col('Finess', '$f'),
          field: 'finess'
        },
        {
          html: col('Email du responsable', '$r'),
          field: 'referent'
        }
      ],
      reaI: function (sheets) {
        const result = [
          {
            html: col('Réa Inf ADI', spe('$ri')),
            field: field('reaInfADI')
          }
        ]

        if (sheets) {
          result.push(
            {
              html: col('Fiches Réa Inf ADI', spe('$ris')),
              field: 'reaInfADISheets'
            }
          )
        }
        result.push(
          {
            html: col('Dia Inf ADI', spe('$di')),
            field: field('diaInfADI')
          }
        )
        if (sheets) {
          result.push(
            {
              html: col('Fiches Dia Inf ADI', spe('$dis')),
              field: 'diaInfADISheets'
            }
          )
        }
        result.push(
          {
            html: col('Néo Inf ADI', spe('$ni')),
            field: field('neoInfADI')
          }
        )
        if (sheets) {
          result.push(
            {
              html: col('Fiches Néo Inf ADI', spe('$nis')),
              field: 'neoInfADISheets'
            }
          )
        }
        return result
      },
      actions: [
        {
          event: 'members',
          name: 'Membres'
        }
      ],
      keyfield: 'id'
    }

    if (lstate.isUser && year !== '2019') {
      common.actions.push(
        { event: 'establishment', name: 'Établissement' },
        { event: 'referent', name: 'Responsable' },
        { event: 'convention', name: 'Charte' },
        { event: 'edit', name: 'Modifier' },
        { event: 'remove', name: 'Supprimer' }
      )
    }

    const columns = [
      {
        name: `Inscription`,
        field: 'registration'
      },
      ...common.columns,
      {
        html: col('Type', '$ty'),
        field: 'estbType'
      },
      {
        html: col('Statut', '$es'),
        field: 'endStatus'
      },
      {
        html: col('Charte', '$cs'),
        field: 'conventionStatus'
      },
      {
        html: col('F. étab.', '$ess'),
        field: 'estbSheetStatus'
      }
    ]

    if (year === '2026') {
      columns.push(
        {
          html: col('F. form.', '$tus'),
          field: 'toolsUsageSheetStatus'
        }
      )
    }

    columns.push(
      {
        html: col('Bact ADI', '$b'),
        field: 'bactADIValue'
      }
    )
    if (sheets) {
      columns.push(
        {
          html: col('Fiches Bact ADI', '$bs'),
          field: 'bactADISheets'
        }
      )
    }
    if (year === '2019') {
      columns.push(
        {
          html: col('Réa Bact ADI', spe('$rb')),
          field: field('reaBactADI')
        }
      )

      if (sheets) {
        columns.push(
          {
            html: col('Fiches Réa Bact ADI', '$rbs'),
            field: 'reaBactADISheets'
          }
        )
      }
      columns.push(
        ...common.reaI(sheets)
      )
    } else {
      columns.push(
        {

          html: col('Exp ADI', spe('$ea')),
          field: field('expADI')
        }
      )
      if (sheets) {
        columns.push(
          {
            html: col('Fiches Exp ADI', '$eas'),
            field: 'expADISheets'
          }
        )
      }
      columns.push(
        ...common.reaI(sheets),
        {
          html: col('OBSERVA4', spe('$o4')),
          field: 'observa4Value'
        }
      )
      if (sheets) {
        columns.push(
          {
            html: col('Fiches Observa4', '$o4s'),
            field: 'observa4Sheets'
          }
        )
      }
    }

    if (year === '2020') {
      columns.push(
        {
          html: col('Réa-Sink', spe('$rs')),
          field: field('reaSink')
        },
        {
          html: col('Statut Réa-Sink', spe('$rss')),
          field: 'reaSinkStatus'
        }
      )
    } else if (year !== '2019') {
      columns.push(
        {
          html: col('RÉA-explAUR', spe('$rx')),
          field: field('reaExplaur')
        },
        {
          html: col('Statut RÉA-explAUR', spe('$rxs')),
          field: 'reaExplaurStatus'
        }
      )

      if (year === '2025') {
        columns.push(
          {
            html: col('Top CVP', spe('$cvp')),
            field: field('topCvp')
          }
        )
      }

      if (year === '2026') {
        columns.push(
          {
            html: col('Badi CAUSE', spe('$bc')),
            field: field('badiCause')
          }
        )
        if (sheets) {
          columns.push(
            {
              html: col('Fiches Badi CAUSE', '$bcs'),
              field: 'badiCauseSheets'
            }
          )
        }
        columns.push(
          {
            html: col('SPY4', spe('$spy4')),
            field: field('spy4')
          }
        )
        if (sheets) {
          columns.push(
            {
              html: col('Fiches SPY4', '$spy4s'),
              field: 'spy4Sheets'
            }
          )
        }
      }
    }

    const actions = [...common.actions]
    if (lstate.isUser) {
      actions.push(
        {
          event: 'datasets',
          name: 'Datasets',
          show: (u) => u.source.hasDatasets()
        }
      )

      if (year === '2020') {
        actions.push(
          {
            event: 'reaSink',
            name: 'Réa-Sink',
            show: (u) => u.source.modules.reaSink != null
          }
        )
      } else if (parseInt(year) >= 2021) {
        actions.push(
          {
            event: 'reaExplaur',
            name: 'RÉA-explAUR',
            show: u => u.source.modules.reaExplaur != null
          }
        )
      }
    }

    return {
      keyfield: common.keyfield,
      initialSort: {
        field: 'registration',
        ascend: false
      },
      columns: columns,
      actions: actions
    }
  }
}
